<template>
  <div>
    <div class="content-header" style="border: none">
      <div class="left">
        <span class="title">通知提醒</span>
      </div>
      <div class="right">
        <span class="btn" @click="addPerson">新增</span>
      </div>
    </div>
    <div class="email_box">
      <Card class="card" v-for="(item, key) in personList" :key="key">
        <div class="content-box" @click.stop="showMadale(item)">
          <div class="left">
            <h3 class="alias">
              {{ item.name }}
              <Icon type="ios-contact" />
            </h3>
            <p
              class="domain_name"
              :class="{ name2: item.openid }"
              @click.stop="showQrModal(item)"
            >
              {{ item.openid ? "更换微信" : "未绑定微信" }}
            </p>
          </div>
          <span class="icon">
            <Icon type="ios-text" size="24" color="#fff" />
          </span>
        </div>
      </Card>
    </div>
    <Modal v-model="modalPerson.visible" width="1000" :closable="false" footer-hide>
      <div slot="header" class="modal_notice_header">
        <span style="font-weight: bold">通知提醒人</span>
        <div>
          <Button @click="modalPerson.visible = false">取消</Button>
          <Button
            type="error"
            style="margin-left: 10px"
            v-if="modalPerson.data.id"
            @click="deletePerson"
            >删除</Button
          >
          <Button type="primary" style="margin-left: 10px" @click="savePerson"
            >保存</Button
          >
        </div>
      </div>
      <div class="modal_notice_content">
        <div>
          <span style="font-size: 15px">提醒人姓名：</span>
          <Input
            v-model="modalPerson.data.name"
            style="width: 260px"
            placeholder="请输入提醒人姓名"
          />
          <span style="margin-left: 60px; font-size: 15px">选择关联设备：</span>
          <Button @click="selectMachine">{{
            modalPerson.data.machine_ids.length > 0 ? "已选择设备" : "选择设备"
          }}</Button>
          <span style="font-size: 12px; color: #666; margin-left: 10px"
            >(默认所有设备)</span
          >
        </div>
        <Row type="flex" justify="start" style="margin: 30px 0">
          <Col span="8">
            <div class="col_item">
              <div class="title_box">
                <p class="tit">设备故障</p>
                <!-- <p class="des">
                  选中的故障发生后，10分钟内没恢复将会进行邮件提醒
                </p> -->
              </div>
              <div class="check_box">
                <CheckboxGroup v-model="errorNotice.params.select">
                  <Checkbox
                    style="display: block; margin-top: 8px; font-size: 12px"
                    v-for="(item, key) in errorNotice.data"
                    :key="key"
                    :label="item.code"
                    >{{ item.text }}</Checkbox
                  >
                </CheckboxGroup>
              </div>
            </div>
          </Col>
          <Col span="8">
            <div class="col_item" style="padding-left: 25px">
              <div class="title_box">
                <p class="tit">印量报表</p>
                <!-- <p class="des">选中的报表，每月1号10点将会进行邮件提醒</p> -->
              </div>
              <div class="check_box">
                <CheckboxGroup v-model="reportNotice.params.select">
                  <Checkbox
                    style="display: block; margin: 8px 0 5px; font-size: 12px"
                    v-for="(item, key) in reportNotice.data"
                    :key="key"
                    :label="item.code"
                    v-model="item.status"
                    >{{ item.text }}</Checkbox
                  >
                </CheckboxGroup>
              </div>
            </div>
          </Col>
          <Col span="8">
            <div class="col_item">
              <div class="title_box">
                <p class="tit">业务信息</p>
              </div>
              <div class="check_box">
                <CheckboxGroup v-model="otherNotice.params.select">
                  <Checkbox
                    style="display: block; margin-top: 5px"
                    v-for="(item, key) in otherNotice.data"
                    :key="key"
                    :label="item.code"
                    v-model="item.status"
                    >{{ item.text }}</Checkbox
                  >
                </CheckboxGroup>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
    <machine
      v-model="showSelectMachine"
      :ids="machine_ids"
      @cancel="showSelectMachine = false"
      @selectResult="machineSelect"
      meter="0,3"
    ></machine>
    <Modal v-model="qrVisible" title="微信绑定" :width="600" footer-hide>
      <div class="tips">
        微信扫码完成绑定后，请手动关闭此窗口，并刷新页面后查看绑定结果！
      </div>
      <div style="text-align: center; margin-top: 20px">
        <canvas
          :style="{ height: '260px', width: '260px' }"
          :height="260"
          :width="260"
          ref="qr"
        ></canvas>
      </div>
      <div style="color: #4788f7; font-size: 16px; margin: 15px 0; text-align: center">
        接收者打开微信扫一扫
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeviceError from '../../config/device_error'
import machine from '_c/machine'
import qr from 'qr.js'
import config from '../../config'
export default {
  components: {
    machine
  },
  data () {
    return {
      personList: [],
      modalPerson: {
        visible: false,
        data: {
          name: '',
          machine_ids: []
        }
      },
      errorNotice: {
        checkAll: false,
        indeterminate: false,
        checkAllGroup: [],
        data: [],
        params: { select: [], switch: false, manual: false }
      },
      reportNotice: {
        data: [
          {
            text: '日印量收益表单',
            status: false,
            code: 'day'
          },
          {
            text: '月印量收益报表',
            status: false,
            code: 'month'
          }
        ],
        params: { select: [], switch: true }
      },
      otherNotice: {
        data: [
          {
            text: '设备运营即将到期、运营到期',
            status: false,
            code: 'machine_operation'
          },
          // {
          //   text: "资金分账",
          //   status: false,
          //   code: "capital_setting",
          // },
          {
            text: '开票申请',
            status: false,
            code: 'invoice'
          },
          {
            text: '增值订单成功生效',
            status: false,
            code: 'increment_order'
          },
          {
            text: '云知印mini配送订单提醒',
            status: false,
            code: 'mini_orders_sent'
          }
        ],
        params: { select: [], switch: true }
      },
      showSelectMachine: false,
      machine_ids: '',
      qrVisible: false
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    ...mapActions(['GetAgentNotice', 'SaveAgentNotice', 'DelNotice']),
    getData () {
      this.GetAgentNotice().then((res) => {
        this.personList = res.data
      })
    },
    addPerson () {
      this.modalPerson = {
        visible: true,
        data: {
          id: null,
          name: '',
          machine_ids: ''
        }
      }
      this.initErrorNotice()
      this.errorNotice.params.select = []
      this.reportNotice.params.select = []
      this.otherNotice.params.select = []
    },
    showMadale (item) {
      this.initErrorNotice()
      this.modalPerson.data.id = item.id
      this.modalPerson.data.name = item.name
      this.modalPerson.data.machine_ids = item.machine_ids || ''
      this.errorNotice.params.select = item.fault ? item.fault.split(',') : []
      this.reportNotice.params.select = item.report ? item.report.split(',') : []
      this.otherNotice.params.select = item.business ? item.business.split(',') : []
      this.modalPerson.visible = true
    },
    initErrorNotice () {
      let data = []
      for (let k in DeviceError) {
        let item = {
          code: k,
          text: DeviceError[k].text,
          status: true
        }
        if (
          item.text == '设备盖打开' ||
          item.text == '纸盒未插入到设备' ||
          item.text == '所有纸盒缺纸' ||
          item.text == '设备发生卡纸' ||
          item.text == '碳粉已使用完' ||
          item.text == '检测到部分单元未正确安装。' ||
          item.text == '其它错误' ||
          item.text == '废粉盒已满' ||
          item.text == '功能性故障(SC代码)' ||
          item.text == '需要更换PM部件' ||
          item.text == '需要尽快更换PM部件' ||
          item.text == '废粉盒即将堆满' ||
          item.text == '碳粉余量不足' ||
          item.text == '设备离线' ||
          item.text == '部份纸盒余量低于10%' ||
          item.text == '部分纸盒缺纸' ||
          item.text == '冲印设备-纸盒缺纸' ||
          item.text == '冲印设备-卡纸' ||
          item.text == '冲印设备-盖板打开' ||
          item.text == '冲印设备-其它错误' ||
          item.text == '冲印设备-墨粉不足' ||
          item.text == '冲印设备-缺粉'
        ) {
          data.push(item)
        }
      }
      if (this.errorNotice.params.switch) {
        if (this.errorNotice.params.select.length === 0) {
          this.errorNotice.checkAll = false
          this.errorNotice.indeterminate = false
        } else if (this.errorNotice.params.select.length == data.length) {
          this.errorNotice.indeterminate = false
          this.errorNotice.checkAll = true
        } else {
          this.errorNotice.indeterminate = true
          this.errorNotice.checkAll = false
        }
      }
      this.errorNotice.data = data
    },
    deletePerson () {
      this.$Modal.confirm({
        title: '是否删除',
        content: '是否删除该通知联系人?',
        onOk: () => {
          this.DelNotice({ id: this.modalPerson.data.id }).then((res) => {
            this.$Message[res.status ? 'success' : 'error'](res.msg)
            if (res.status) {
              this.modalPerson.visible = false
              this.getData()
            }
          })
        }
      })
    },
    savePerson () {
      let data = this.modalPerson.data
      if (!data.name) {
        this.$Message.error('请输入提醒人姓名!')
        return
      }
      if (
        this.errorNotice.params.select.length == 0 &&
        this.reportNotice.params.select.length == 0 &&
        this.otherNotice.params.select.length == 0
      ) {
        this.$Message.error('请至少勾选一项!')
        return
      }
      data.fault = this.errorNotice.params.select.join(',')
      data.report = this.reportNotice.params.select.join(',')
      data.business = this.otherNotice.params.select.join(',')
      console.log('保存参数', data)
      if (!this.modalPerson.data.machine_ids) {
        this.modalPerson.data.machine_ids = 'all'
      }
      this.SaveAgentNotice(data).then((res) => {
        this.$Message[res.status ? 'success' : 'error'](res.msg)
        if (res.status) {
          this.modalPerson.visible = false
          this.getData()
        }
      })
    },
    selectMachine () {
      this.showSelectMachine = true
      this.machine_ids = this.modalPerson.data.machine_ids
    },
    machineSelect (e) {
      this.modalPerson.data.machine_ids = e
      this.showSelectMachine = false
    },
    showQrModal (data) {
      this.qrVisible = true
      // this.filename = `${data.name}微信绑定二维码`;
      try {
        var $qr = this.$refs.qr
        var qrcode = qr(
          `${config.baseUrl.pro}/wechat/api/wx/code?back=/wechat/tips?type=success&info=1_${data.id}`
        )
        var ctx = $qr.getContext('2d')
        var cells = qrcode.modules
        var tileW = 260 / cells.length
        var tileH = 260 / cells.length
        var scale = (window.devicePixelRatio || 1) / this.getBackingStorePixelRatio(ctx)
        $qr.height = $qr.width = 260 * scale
        ctx.scale(scale, scale)
        cells.forEach((row, rdx) => {
          row.forEach((cell, cdx) => {
            ctx.fillStyle = cell ? '#000000' : '#FFFFFF'
            var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW)
            var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH)
            ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h)
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    getBackingStorePixelRatio (ctx) {
      return (
        ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio ||
        1
      )
    }
  },
  computed: mapGetters({}),
  watch: {}
}
</script>
<style lang="less">
@import "./index.less";
</style>
